export const SET_CURRENT_TAB =
  'client/modules/cbi-entity/redux/actions/tab/SET_CURRENT_TAB';

export function setCurrentTab(currentTab) {
  return { type: SET_CURRENT_TAB, currentTab };
}
